/**
 * Grüns-style treatment buy box (Intelligems `ig-grunz-pdp` experiment)
 *
 * This path is now rolled out to 100% for the Flow PDP. The snippet adds
 * `ig-grunz-pdp` inline as soon as the ready treatment renders; this script
 * also self-applies it so previews and section reloads stay in the treatment.
 * CSS keeps the control buy box rendered but hidden. This script keeps the
 * plan cards in sync with the product form (variant inputs, Flow+ selector
 * mode, and the floating buy card).
 */
(function () {
  var TREATMENT_CLASS = 'ig-grunz-pdp';
  var containers = Array.prototype.slice.call(document.querySelectorAll('[data-grunz-buy-box]'));
  if (!containers.length) return;

  var treatmentActive = false;

  forceTreatment();
  containers.forEach(bindContainer);
  syncTreatmentState();

  if (window.MutationObserver) {
    new MutationObserver(syncTreatmentState).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncTreatmentState(true);
  });

  function forceTreatment() {
    document.documentElement.classList.add(TREATMENT_CLASS);
  }

  function syncTreatmentState(force) {
    var nextActive = document.documentElement.classList.contains(TREATMENT_CLASS);
    if (nextActive === treatmentActive && !force) return;

    treatmentActive = nextActive;
    containers.forEach(function (container) {
      if (treatmentActive) {
        activate(container);
      } else {
        deactivate(container);
      }
    });
  }

  function activate(container) {
    var productForm = container.closest('product-form');
    if (productForm) {
      productForm.dataset.flowPlusEnabled = 'true';
      productForm.dataset.flowPlusMode = 'selector';
    }
    syncSelection(container);
  }

  function deactivate(container) {
    var productForm = container.closest('product-form');
    if (productForm) {
      productForm.dataset.flowPlusEnabled = 'false';
      delete productForm.dataset.flowPlusMode;
    }

    var cardRoot = document.getElementById('PdpFloatingBuyCard-' + container.dataset.sectionId);
    if (cardRoot) cardRoot.classList.remove('is-grunz-sub');
    // Let the control dock selector reclaim the form inputs.
    document.dispatchEvent(new CustomEvent('flow:dock-selector-treatment-changed'));
  }

  function bindContainer(container) {
    container.querySelectorAll('.grunz-qty__input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        setQuantity(container, input.value);
      });
    });

    container.querySelectorAll('.grunz-plan__input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        setPlan(container, input.closest('.grunz-plan'));
      });
    });
  }

  function setQuantity(container, qty) {
    container.dataset.qty = qty;

    container.querySelectorAll('.grunz-qty__pill').forEach(function (pill) {
      var input = pill.querySelector('.grunz-qty__input');
      pill.classList.toggle('is-active', Boolean(input && input.checked));
    });

    container.querySelectorAll('.grunz-plan').forEach(function (card) {
      var variantId = card.dataset['variantIdQty' + qty];
      var dockCount = card.dataset['dockCountQty' + qty];
      if (variantId) card.dataset.variantId = variantId;
      if (dockCount) card.dataset.dockCount = dockCount;
    });

    syncSelection(container);
  }

  function setPlan(container, activeCard) {
    container.querySelectorAll('.grunz-plan').forEach(function (card) {
      card.classList.toggle('is-active', card === activeCard);
    });

    syncSelection(container);
  }

  function syncSelection(container) {
    if (!treatmentActive) return;

    var card = getActiveCard(container);
    if (!card || !card.dataset.variantId) return;

    var sectionId = container.dataset.sectionId;
    var variantId = card.dataset.variantId;

    syncVariantInputs(sectionId, variantId);
    syncQuantityInputs(sectionId, card.dataset.dockQuantity || '1');
    syncFloatingBuyCard(container, card);

    document.dispatchEvent(
      new CustomEvent('flow:dock-selection-changed', {
        detail: {
          sectionId: String(sectionId),
          variantId: String(variantId),
          dockQuantity: String(card.dataset.dockQuantity || '1'),
        },
      })
    );
  }

  function getActiveCard(container) {
    return (
      container.querySelector('.grunz-plan.is-active[data-variant-id]') ||
      container.querySelector('.grunz-plan[data-variant-id]')
    );
  }

  function syncVariantInputs(sectionId, variantId) {
    document
      .querySelectorAll(
        '#ProductInfo-' +
          sectionId +
          ' input.product-variant-id, #ProductInfo-' +
          sectionId +
          ' #product-form-installment-' +
          sectionId +
          ' input[name="id"]'
      )
      .forEach(function (input) {
        input.value = variantId;
        input.disabled = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  function syncQuantityInputs(sectionId, quantity) {
    document
      .querySelectorAll('#ProductInfo-' + sectionId + ' product-form input[name="quantity"], #Quantity-' + sectionId)
      .forEach(function (input) {
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  function syncFloatingBuyCard(container, card) {
    if (!card) return;

    var cardRoot = document.getElementById('PdpFloatingBuyCard-' + container.dataset.sectionId);
    if (cardRoot) {
      cardRoot.classList.toggle('is-grunz-sub', card.dataset.grunzPlan === 'sub');
    }

    var button = document.getElementById('PdpFloatingBuyCardSubmit-' + container.dataset.sectionId);
    if (!button) return;

    var qty = container.dataset.qty || '1';
    var priceSource = card.querySelector('[data-price-kind="price"][data-qty-state="' + qty + '"]');
    var compareSource = card.querySelector('[data-price-kind="compare"][data-qty-state="' + qty + '"]');
    var priceDestination = button.querySelector('[data-floating-buy-card-price]');
    var compareDestination = button.querySelector('[data-floating-buy-card-compare]');
    var countDestination = button.querySelector('[data-floating-buy-card-count]');

    if (priceSource && priceDestination) {
      priceDestination.textContent = priceSource.textContent.trim();
      copyPriceAttributes(priceDestination, priceSource);
    }

    if (compareDestination) {
      if (compareSource && compareSource.textContent.trim()) {
        compareDestination.textContent = compareSource.textContent.trim();
        compareDestination.hidden = false;
        copyPriceAttributes(compareDestination, compareSource);
      } else {
        compareDestination.textContent = '';
        compareDestination.hidden = true;
      }
    }

    if (countDestination) {
      countDestination.textContent = card.dataset.dockCount || '1';
    }
  }

  function copyPriceAttributes(destination, source) {
    ['data-product-id', 'data-variant-id'].forEach(function (attribute) {
      var value = source.getAttribute(attribute);
      if (value === null) {
        destination.removeAttribute(attribute);
      } else {
        destination.setAttribute(attribute, value);
      }
    });
  }
})();
